import { createSlice } from "@reduxjs/toolkit";
import { IUser } from "src/common/typings/user";
import { RootState } from "../store";
import {
  currentUserAction,
  handleLogin,
  loginAction,
  loginFailed,
  logOutAction,
  setPasswordAction,
  chackValidateUserAction,
} from "./actions/authActions";

export interface AuthState {
  user?: IUser;
  status: "idle" | "loading" | "failed" | "passwordResetRequired" | "PasswordResetSuccessfull";
  resetEmail?: string;
  authError?: string;
}

const initialState: AuthState = {
  status: "idle",
};

export const authSlice = createSlice({
  name: "auth",
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    resetErrorAction: (state) => {
      delete state.authError;
    },
  },
  // The `extraReducers` field lets the slice handle actions defined elsewhere,
  // including actions generated by createAsyncThunk or in other slices.
  extraReducers: (builder) => {
    builder
      .addCase(loginAction.pending, (state) => {
        state.status = "loading";
        delete state.authError;
      })
      .addCase(loginAction.fulfilled, handleLogin)
      .addCase(loginAction.rejected, loginFailed)

      .addCase(currentUserAction.pending, (state) => {
        state.status = "loading";
      })
      .addCase(currentUserAction.fulfilled, handleLogin)
      .addCase(currentUserAction.rejected, (state) => {
        state.status = "failed";
      })

      .addCase(logOutAction.pending, (state) => {
        state.status = "loading";
      })
      .addCase(logOutAction.fulfilled, (state) => {
        state.status = "idle";
        delete state.user;
      })
      .addCase(logOutAction.rejected, (state) => {
        state.status = "failed";
      })

      .addCase(setPasswordAction.pending, (state) => {
        state.status = "loading";
      })
      .addCase(setPasswordAction.fulfilled, (state) => {
        state.status = "PasswordResetSuccessfull";
        delete state.user;
      })
      .addCase(setPasswordAction.rejected, (state) => {
        state.status = "failed";
        delete state.user;
        state.authError = "An Unexpected Error Occurred";
      });
  },
});

export const { resetErrorAction } = authSlice.actions;

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state: RootState) => state.counter.value)`
export const selectStatus = (state: RootState) => state.auth.status;
export const selectResetEmail = (state: RootState) => state.auth.resetEmail;
export const selectAuthError = (state: RootState) => state.auth.authError;
export const selectUser = (state: RootState) => state.auth.user;
export const isLogin = (state: RootState) => {
  return Boolean(state.auth.user?.Username);
};
